/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostThreeMFormInput = {|
  address: string,
  email: string,
  firstname: string,
  invoiceNumber: string,
  phone: string,
  reason: string,
  surname: string,
|};
export type PostThreeMFormMutationVariables = {|
  input: PostThreeMFormInput
|};
export type PostThreeMFormMutationResponse = {|
  +postThreeMForm: ?{|
    +result: ?boolean
  |}
|};
export type PostThreeMFormMutation = {|
  variables: PostThreeMFormMutationVariables,
  response: PostThreeMFormMutationResponse,
|};
*/


/*
mutation PostThreeMFormMutation(
  $input: PostThreeMFormInput!
) {
  postThreeMForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostThreeMFormPayload",
    "kind": "LinkedField",
    "name": "postThreeMForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostThreeMFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostThreeMFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d360b8ce752e4193de1675ba8821dd5b",
    "id": null,
    "metadata": {},
    "name": "PostThreeMFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostThreeMFormMutation(\n  $input: PostThreeMFormInput!\n) {\n  postThreeMForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5bb317cdaceeb305fa954d8a677d92c1';

module.exports = node;
